<div :class="['modal', 'small'].concat(classes)" v-on:keyup.esc="buttons[0].action">
  <div class="modal-content container">
    <div class="row">
      <div class="col s12">
        <h5 v-if="title">{{title}}</h5>
        <p v-html="text"></p>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button v-for="button of buttons" ref="buttons"
            class="btn-flat teal-text waves-effect waves-light"
            @click="button.action">
      {{button.text}}
    </button>
  </div>
</div>
